import React, { PureComponent } from 'react';
// import { NavLink } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import ProviderCmp from '../../shared/components/providers/provider-cmp';

export default class AddProviderPage extends PureComponent {

  constructor() {
    super();
    this.state = {
    };
  }

  render() {
    return(<Container>
      <h3 className="page-title mb-3">Ajouter un fournisseur</h3>
      <ProviderCmp history={this.props.history} adding={true} />
    </Container>)
  }
}
